<dx-form class="gpd-form" [validationGroup]="validationGroup" [colCount]="1" [showColonAfterLabel]="false">
  @for (role of projectData.roles; track role.departmentId) {
    <dxi-item [dataField]="role.departmentId">
      <dxo-label [text]="role.departmentName"></dxo-label>
        <app-holder-select
          [users]="users"
          [departments]="departments"
          [(email)]="role.userMail"
          [(departmentId)]="role.assignedDepartmentId"
        ></app-holder-select>
    </dxi-item>
  }
</dx-form>